/**
 * Formata segundos no padrão "Xd Xh Xm Xs" (omitindo unidades zeradas
 * superiores). Usado em InfosBar (header) e SessionInfo (footer v2).
 */
export function formatWithLeadingZero(value: number): string {
  return value < 10 ? `0${value}` : `${value}`;
}

export function formatTime(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds || 0));
  const days = Math.floor(safe / (24 * 3600));
  const hours = Math.floor((safe % (24 * 3600)) / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const secs = safe % 60;

  let out = '';

  if (days > 0) out += `${formatWithLeadingZero(days)}d `;
  if (hours > 0) out += `${formatWithLeadingZero(hours)}h `;
  if (minutes > 0) out += `${formatWithLeadingZero(minutes)}m `;
  out += `${formatWithLeadingZero(secs)}s`;

  return out.trim();
}
